import {useSelector} from "react-redux";

import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../ab_testing/ab_testing_instance";
import {OngoingABTests, PhoneCodeVerificationVariant} from "../ab_testing/ongoing_ab_tests";
import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";
import {checkHasVerifiedPhone} from "../user/utils/check_has_verified_phone";

const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.PHONE_CODE_VERIFICATION);
export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);
    const testProps = useABTest(abTestProps);

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);
    const hasPhoneVerified = checkHasVerifiedPhone(userInfo);
    const isUserLoggedIn = Boolean(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    let shouldHidePrices: boolean;
    switch (testProps.abTestVariant) {
        case PhoneCodeVerificationVariant.ACTIVE:
            shouldHidePrices = (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked;
            break;
        case PhoneCodeVerificationVariant.INACTIVE:
        default:
            shouldHidePrices = !hasCompleteProfile && !isPricesUnlocked;
            break;
    }
    return {
        shouldHidePrices,
        hasCompleteProfile,
        //hardcode true if variant is not active to not block the flow for users outside of the AB test
        hasPhoneVerified: testProps.abTestVariant === PhoneCodeVerificationVariant.ACTIVE ? hasPhoneVerified : true,
        isUserLoggedIn
    };
};
import {useSelector} from "react-redux";

import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../ab_testing/ab_testing_instance";
import {OngoingABTests, PhoneCodeVerificationVariant} from "../ab_testing/ongoing_ab_tests";
import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";
import {checkHasVerifiedPhone} from "../user/utils/check_has_verified_phone";

const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.PHONE_CODE_VERIFICATION);
export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);
    const testProps = useABTest(abTestProps);

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);
    const hasPhoneVerified = checkHasVerifiedPhone(userInfo);
    const isUserLoggedIn = Boolean(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    let shouldHidePrices: boolean;
    switch (testProps.abTestVariant) {
        case PhoneCodeVerificationVariant.ACTIVE:
            shouldHidePrices = (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked;
            break;
        case PhoneCodeVerificationVariant.INACTIVE:
        default:
            shouldHidePrices = !hasCompleteProfile && !isPricesUnlocked;
            break;
    }
    return {
        shouldHidePrices,
        hasCompleteProfile,
        //hardcode true if variant is not active to not block the flow for users outside of the AB test
        hasPhoneVerified: testProps.abTestVariant === PhoneCodeVerificationVariant.ACTIVE ? hasPhoneVerified : true,
        isUserLoggedIn
    };
};
